import { FormattedMessage as FM } from "react-intl";

import CardMainMenu from "componentsv2/card/CardsMainMenu";

const MainMenu = ({ views, desc, columns = 3 }) => {
  const cols = Math.min(columns, views.length) || 1;
  const cardWidth = 254.33; // (863 - 2*50) / 3 — tamaño actual de card
  const gap = 50;
  const gridWidth = cardWidth * cols + gap * (cols - 1);

  return (
    <div className="h-full content-center md:mx-auto md:w-[920px] md:-mt-20 w-full text-sm md:text-base">
      <h2 className="text-[#374254FF] md:text-[25px] text-base line-clamp-3 font-light max-w-[826px] text-center leading-[1.2] family-[Roboto] mx-auto">
        <FM id={desc} />
      </h2>
      <div
        className="md:grid md:gap-[50px] mt-11 mx-auto"
        style={{
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          width: gridWidth,
        }}
      >
        {views.map((item, index) => (
          <CardMainMenu key={index} item={item} />
        ))}
      </div>
    </div>
  );
};

export default MainMenu;
